let accessToken: string | null = null

export function writeAccessToken(token: string) {
  accessToken = token
}

export function readAccessToken(): string | null {
  return accessToken
}

export function hasAccessToken(): boolean {
  return accessToken !== null
}

export function clearAccessToken() {
  accessToken = null
}
